import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ListItem } from "components/core";
import ListItemIcon from "components/Schedule/ListItemIcon";
import ListItemStatus from "components/Schedule/ListItemStatus";
import { dateToString } from "helpers/dateUtilities";
import { buildFormPageUrl } from "helpers/redirectUtilities";
import { useActiveMenu } from "hooks/useActiveMenu";

export default function ListItemDaily({
  todayEntries,
  date,
  dateToday,
  formId,
  className,
  onClick,
  ...other
}) {
  let navigate = useNavigate();
  const { activeMenu } = useActiveMenu();

  const [entry, setEntry] = useState(undefined);

  const abortControllerRef = useRef(undefined);

  //#region Callbacks

  /**
   * Handle list item click
   */
  const handleClick = () => {
    const recordId = date.getTime();

    return navigate(
      buildFormPageUrl(
        activeMenu,
        formId,
        null,
        null,
        recordId
      )
    );
  };

  //#endregion

  //#region Side-effects

  /**
   * Mount/Unmount
   */
  useEffect(
    () => {
      abortControllerRef.current = new AbortController();

      return () => abortControllerRef.current.abort();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  /**
   * Set entry
   */
  useEffect(() => {
    if (!todayEntries) return;

    const _newEntry = todayEntries?.find(
      (e) => e.FormName.toLowerCase() === "production"
    );
    setEntry(_newEntry ?? null);
  }, [todayEntries]);

  //#endregion

  return (
    <ListItem aria-label="daily" onClick={() => handleClick()} {...other}>
      <ListItemIcon
        dataStatus={entry?.Status}
        networkStatus={entry?._SendStatus}
        date={date}
        dateToday={dateToday}
      />
      <div className="flex-grow">
        <div className="font-medium">Daily</div>
        <div className="flex text-xs uppercase">
          <ListItemStatus
            dataStatus={entry?.Status}
            networkStatus={entry?._SendStatus}
            date={date}
            dateToday={dateToday}
          />
        </div>
        {entry && entry._LastModified && (
          <div className="text-xs text-gray-400">
            Updated:{" "}
            {dateToString(entry._LastModified.localised, {
              includeTime: true,
            })}
          </div>
        )}
      </div>
    </ListItem>
  );
}
